<div>
    <table class="elem-table__table">

        <thead>
        <tr>
            @for (tableHeader of tableHeaders; track tableHeader) {
                <th
                    [ngClass]="getActiveSortCssClass(tableHeader)"
                    scope="col"
                    class="elem-table__col-header"
                    role="columnheader">
                    @if (tableHeader.sortable) {
                        <div role="button"
                             class="elem-table__col-header__container elem-table__col-header__container--sortable"
                             (click)="onHeaderColumnClick(tableHeader)">
                            <div class="elem-table__col-header__lbl">{{ tableHeader.label }}</div>
                            <div class="elem-table__sort-icons">
                                <span class="elem-table__sort-icon-asc">&#9650;</span>
                                <br>
                                <span class="elem-table__sort-icon-desc">&#9660;</span>
                            </div>
                        </div>
                    } @else {
                        <div class="elem-table__col-header__container">
                            <div class="elem-table__col-header__lbl">{{ tableHeader.label }}</div>
                        </div>
                    }
                </th>
            }
        </tr>
        </thead>

        <tbody class="elem-table__tbody">
            @for (line of visibleTableData; track line; let i = $index) {
                <tr
                    [class.elem-table__row--selected]="selectedRowIndex === i"
                    (click)="onTableRowClick(line, i)">
                    @for (tableHeader of tableHeaders; track tableHeader) {
                        <td
                            class="elem-table__table__cell">
                            {{ line[tableHeader.id] }}
                        </td>
                    }
                </tr>
            }
        </tbody>

    </table>
</div>

@if (activatePagination && numPages > 1) {
    <div class="elem-table__pagination">
        <div class="rotate-180" style="width: 2rem;">
            @if (pageOffset !== 0) {
                <button
                    type="button"
                    class="pagination-chevron-btn"
                    (click)="onPrevPageClick()">
                    <i class="vhvicon vhvicon-chevron-big"></i>
                </button>
            }
        </div>
        <div>
            @for (index of pages; track index) {
                <button
                    type="button"
                    class="pagination-btn"
                    [disabled]="pageOffset === index"
                    (click)="onPageNumberClick(index)">
                    {{ index + 1 }}
                </button>
            }
        </div>
        <div style="width: 2rem;">
            @if (pageOffset !== this.numPages - 1) {
                <button
                    type="button"
                    class="pagination-chevron-btn"
                    (click)="onNextPageClick()">
                    <i class="vhvicon vhvicon-chevron-big"></i>
                </button>
            }
        </div>
    </div>
}
